import paymentAuthorisationFailInfo from '#frontend/util/paymentAuthorisationFailInfo.js';

export default (cart, error) => ({
	event: 'paymentAuthorisationFailed',
	paymentAuthorisationFailInfo: paymentAuthorisationFailInfo(error),
	orderId: cart.order.id,
	contentGroup: cart.order.contentGroup
});
